import config from 'config';
import { PLAYBACK_TYPE, PLAYER_SIZES } from './constants';
import { CreativeType } from '../types/creative';

// from Radius
export const fileUrl = (filePath: string, s3 = 'cdn') => {
  let filePathNoSlash = filePath;
  if (filePath[0] === '/') {
    filePathNoSlash = filePath.substring(1);
  }
  if (filePathNoSlash.indexOf('/') >= 0 && s3 === 'cdn') {
    return `${config.fileHost}${filePathNoSlash}`;
  }
  if (filePathNoSlash.indexOf('/') >= 0 && s3 === 'direct') {
    return `${config.s3Direct}${filePathNoSlash}`;
  }
  return `${config.fileHost}video-images/${filePathNoSlash}`;
};

export const loadExternalResources = async (resource: string) => {
    return new Promise(function (resolve, reject) {
      if(resource.endsWith('js')) {
        const script:HTMLScriptElement = document.createElement('script');
        script.src = resource;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      }  else {
        const head  = document.getElementsByTagName('head')[0];
        const link  = document.createElement('link');
        link.rel  = 'stylesheet';
        link.type = 'text/css';
        link.href = resource;
        link.media = 'all';
        link.onload = resolve;
        link.onerror = reject;
        head.appendChild(link);
      }
    }); 
}

export const getPlaybackName = (id) => {
  return Object.keys(PLAYBACK_TYPE).find(key => PLAYBACK_TYPE[key] === id);
}
  

export const getCreativeDimensions = (creative:CreativeType, w:number|null, h:number|null ) => {
  const { aspect_ratio, height, width } = creative?.media_asset?.metadata;

  if(w) {
    return {width:w, height: Math.round(w / aspect_ratio)}
  }
  if(h) {
    return {width:Math.round(h * aspect_ratio), height: h}
  }

  return {width, height}
}

export const buildCreativeSizes = (data) => {
  const { playback_id, media_asset } = data as CreativeType
  const { aspect_ratio } = media_asset.metadata;
  const isVerticalCreative = aspect_ratio < 1;
  const format = isVerticalCreative ? 'vertical' : 'horizontal';
  const dropdown:any[] = [];
  for (const [key, value] of Object.entries(PLAYER_SIZES)) {
    // force custom vertical 
    let w, h
    if(playback_id === PLAYBACK_TYPE.social) {
      w = Math.round(value['vertical'] * .5);
      h = value['vertical']; 
    } else {
      w = !isVerticalCreative ? value[format] : Math.round(value[format] * aspect_ratio);
      h = !isVerticalCreative ? Math.round(value[format] / aspect_ratio) : value[format];
    }
    const obj = {label: key, key: `menu-${value.key}`, size: {width: w, height: h}}
    dropdown.push(obj)
  }

  return dropdown;
}